import { API_BASE_URL } from '../config'
import axios from 'axios'
import { getRecentTexts } from '../actions/text'

export const LIST_USER_EDITS = 'LIST_EDITS'
export const listUserEdits = edits => ({
	type: LIST_USER_EDITS,
	edits
})

export const getUserEdits = uid => dispatch => {
	axios
		.get(`${API_BASE_URL}/edit/${uid}`)
		.then(res => {
			dispatch(listUserEdits(res.data))
		})
}

export const LIST_ALL_EDITS = 'LIST_ALL_EDITS'
export const listAllEdits = edits => ({
	type: LIST_ALL_EDITS,
	edits
})

export const getAllEdits = (texts) => dispatch => {
	let textIds = texts.map(text => text._id)

	axios
		.post(`${API_BASE_URL}/edit/all`, {
			textIds
		})
		.then(res => {
			dispatch(listAllEdits(res.data))
		})
}
 
export const sendEditToApi = (textObj) => dispatch => {
	const { textId, body, title, authorId, authorName, editorId, editorName, editorComment } = textObj
	axios
		.post(`${API_BASE_URL}/edit`, {
			textId,
			title,
			body,
			authorId,
			authorName,
			editorId,
			editorName,
			editorComment
		})
		.then(res => {
			dispatch(getRecentTexts())
			dispatch(getUserEdits(res.data.editorId))
		})
}

export const deleteEditFromApi = (id, uid) => dispatch => {
	axios
		.delete(`${ API_BASE_URL }/edit/${ uid }/${ id }`)
		.then(res => {
			dispatch(listUserEdits(res.data))
		})
}


// WEBPACK FOOTER //
// ./src/actions/edit.js